import { render } from "./index.vue?vue&type=template&id=726f82ae&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=726f82ae&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/ecom_ecom-offical-website_node_sharelib_cicd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726f82ae"]])

export default __exports__